export const PROMOTIONS_SET_PROMOS = 'PROMOTIONS_SET_PROMOS';
